export default "__VITE_ASSET__ca2d0ecf__$_?react__"